// Note: the trailing slash is importnat at the end of the urls

import { landingRewrites } from 'utils/packageLandingPages';
import { favouritesRewrites } from 'utils/favouriteHotels';

const rewrites: any = {
  '/rolunk/': /* url that the user visits */ {
    locale: 'hu',
    rewriteUrl: '/about-us/', // the route that is rendered
  },
  '/kapcsolat/': {
    locale: 'hu',
    rewriteUrl: '/contact/',
  },
  '/foglalasok/': {
    locale: 'hu',
    rewriteUrl: '/bookings/',
  },
  '/kosar/': {
    locale: 'hu',
    rewriteUrl: '/cart/',
  },
  '/gyik/': {
    locale: 'hu',
    rewriteUrl: '/faq/',
  },
  '/karrier/': {
    locale: 'hu',
    rewriteUrl: '/jobs/',
  },
  '/ertesitesek/': {
    locale: 'hu',
    rewriteUrl: '/notifications/',
  },
  '/adatvedelmi-nyilatkozat/': {
    locale: 'hu',
    rewriteUrl: '/privacy-policy/',
  },
  '/talalatok/': {
    locale: 'hu',
    rewriteUrl: '/results/',
  },
  '/beallitasok/': {
    locale: 'hu',
    rewriteUrl: '/settings/',
  },
  '/hasznalati-feltetelek/': {
    locale: 'hu',
    rewriteUrl: '/terms-and-conditions/',
  },
  // WHIT-485: the incumbent's address for the same form.
  '/gyors-ajanlatkeres/': {
    locale: 'hu',
    rewriteUrl: '/quote-request/',
  },
  // The package-tour pages' addresses (/csomagtura/…, /csak-szallas/…) are
  // not keys here: one page serves two addresses, by product. See
  // utils/productPaths (WHIT-505).
  // WHIT-485 round 2: the destination and theme pages, at the incumbent's
  // addresses.
  ...landingRewrites(),
  ...favouritesRewrites(),
};
export const findKeyByRewriteUrl = (
  targetUrl: string,
  locale: string = 'en',
) => {
  // Return the translated url based on the target url and the locale
  // For english language the target url will be returned by default
  // If the language is not english and no translated url was found the base url (main page) will be returned
  if (locale === 'en') return targetUrl;
  return (
    Object.keys(rewrites).find(
      path =>
        rewrites[path].rewriteUrl === targetUrl &&
        locale === rewrites[path].locale,
    ) || '/'
  );
};

export default rewrites;
